import React, { ReactElement } from 'react';
import { ICancelIconProps } from './types';
import { SCSvgPath, SCSvgRoot, SCSvgWrapper } from './styles';

const CancelIcon = ({ iconState, disabled }: ICancelIconProps): ReactElement => {
    return (
        <SCSvgWrapper
            data-testid={'cancel_icon'}
            aria-disabled={disabled ? 'true' : 'false'}
            role="img"
            aria-label="Cancel icon"
        >
            <SCSvgRoot
                aria-labelledby="Cancel icon"
                role="group"
                width="100%"
                height="100%"
                viewBox="0 0 22 22"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlSpace="preserve"
            >
                <SCSvgPath
                    animate={iconState}
                    data-testid={iconState ? 'CancelIconActive1' : 'CancelIconInactive1'}
                    disabled={disabled}
                    d="M14.0625 4.6875C14.0625 7.27633 11.9638 9.375 9.375 9.375C6.78617 9.375 4.6875 7.27633 4.6875 4.6875C4.6875 2.09867 6.78617 0 9.375 0C11.9638 0 14.0625 2.09867 14.0625 4.6875ZM9.375 7.8125C11.1009 7.8125 12.5 6.41339 12.5 4.6875C12.5 2.96161 11.1009 1.5625 9.375 1.5625C7.64911 1.5625 6.25 2.96161 6.25 4.6875C6.25 6.41339 7.64911 7.8125 9.375 7.8125Z"
                />
                <SCSvgPath
                    animate={iconState}
                    data-testid={iconState ? 'CancelIconActive2' : 'CancelIconInactive2'}
                    disabled={disabled}
                    d="M9.77509 18.75C9.59866 18.2508 9.47699 17.7258 9.41731 17.1821H1.5625C1.56473 16.7965 1.80274 15.6413 2.86265 14.5814C3.8818 13.5623 5.79825 12.5 9.37498 12.5C9.78201 12.5 10.1675 12.5138 10.5327 12.5396C10.8845 12.0063 11.307 11.5237 11.7869 11.1052C11.0579 10.9971 10.2562 10.9375 9.375 10.9375C1.5625 10.9375 0 15.625 0 17.1875C0 18.75 1.5625 18.75 1.5625 18.75H9.77509Z"
                />
                <SCSvgPath
                    animate={iconState}
                    data-testid={iconState ? 'CancelIconActive3' : 'CancelIconInactive3'}
                    disabled={disabled}
                    d="M16.4062 21.875C19.4266 21.875 21.875 19.4266 21.875 16.4062C21.875 13.3859 19.4266 10.9375 16.4062 10.9375C13.3859 10.9375 10.9375 13.3859 10.9375 16.4062C10.9375 19.4266 13.3859 21.875 16.4062 21.875ZM15.3962 14.2913L16.4062 15.3014L17.4163 14.2913C17.7214 13.9862 18.2161 13.9862 18.5212 14.2913C18.8263 14.5964 18.8263 15.0911 18.5212 15.3962L17.5111 16.4062L18.5212 17.4163C18.8263 17.7214 18.8263 18.2161 18.5212 18.5212C18.2161 18.8263 17.7214 18.8263 17.4163 18.5212L16.4062 17.5111L15.3962 18.5212C15.0911 18.8263 14.5964 18.8263 14.2913 18.5212C13.9862 18.2161 13.9862 17.7214 14.2913 17.4163L15.3014 16.4062L14.2913 15.3962C13.9862 15.0911 13.9862 14.5964 14.2913 14.2913C14.5964 13.9862 15.0911 13.9862 15.3962 14.2913Z"
                />
            </SCSvgRoot>
        </SCSvgWrapper>
    );
};

export { CancelIcon };
